import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useScore } from './ScoreContext';
export function StickyWidget() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isScrolled || answeredCount === 0) return null;
  const title = answeredCount >= 4 ? "You're halfway there" : 'Score started';
  const handleFinishClick = () => {
    openDiagnostic();
  };
  const dots = Array.from({
    length: 8
  });
  return <>
      {/* Desktop card — lower right, paper surface, calm progress cue */}
      <div className="hidden md:flex fixed bottom-8 right-8 z-50 bg-paper text-navy p-5 rounded-2xl shadow-[0_24px_48px_-18px_rgba(26,40,56,0.28)] border border-gray-200/70 flex-col gap-3.5 animate-in slide-in-from-bottom-4 fade-in duration-500 w-[19rem]" data-id="element-552" data-mp="1rlscix37jr3v">
        <div className="flex items-center justify-between gap-4" data-id="element-553" data-mp="36fzcvyujpcsi">
          <div data-id="element-554" data-mp="36hsj5d18xuzz">
            <div className="text-xs font-semibold text-seaglass uppercase tracking-[0.18em] mb-1" data-id="element-555" data-mp="3keyzz22etjmk">
              {title}
            </div>
            <div className="text-sm text-text-muted font-medium" data-id="element-556" data-mp="3fhfmw5hg7cw7">
              {answeredCount} of 8 answered
            </div>
          </div>
          <button onClick={handleFinishClick} className="text-sm font-semibold text-white bg-[#d4a574] hover:bg-[#c89860] px-4 py-2.5 rounded-xl flex items-center gap-2 transition-colors flex-shrink-0" data-id="element-557" data-mp="2ro764b8th72e">
            
            Finish <ArrowRight className="w-4 h-4" data-id="element-558" data-mp="2wpwhjrzybmr0" />
          </button>
        </div>
        {/* Segmented sea-glass progress cue — no ring, no meter */}
        <div className="flex items-center gap-1.5" data-id="element-559" data-mp="28yhf7z86d5fr">
          {dots.map((_, i) => <div key={i} className={`h-1.5 flex-1 rounded-full ${i < answeredCount ? 'bg-seaglass' : 'bg-gray-200'}`} data-id="element-560" data-mp="23zxqxs63zhk8" data-mpi={i}>
          </div>)}
        </div>
      </div>

      {/* Mobile bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-paper text-navy px-4 py-3 shadow-[0_-10px_30px_rgba(26,40,56,0.12)] border-t border-gray-200/70 flex items-center justify-between animate-in slide-in-from-bottom-full duration-300" data-id="element-561" data-mp="cw49n2ov18it">
        <div className="flex items-center gap-2 text-sm" data-id="element-562" data-mp="lrbtbzkvmwgw">
          <span className="font-semibold" data-id="element-563" data-mp="3l5e81knsgl9d">Score</span>
          <span className="text-gray-300" data-id="element-564" data-mp="3q3fri6p4mmld">&middot;</span>
          <span className="text-seaglass font-semibold" data-id="element-565" data-mp="3q3z9toiovczx">{answeredCount}/8</span>
        </div>
        <button onClick={handleFinishClick} className="text-sm font-semibold text-white bg-[#d4a574] hover:bg-[#c89860] px-4 py-2 rounded-lg flex items-center gap-1.5" data-id="element-566" data-mp="3u49g72ae85fb">
          
          Finish <ArrowRight className="w-3.5 h-3.5" data-id="element-567" data-mp="19ds5ddc6kjvt" />
        </button>
      </div>
    </>;
}